<template>
	<Transition name="fade">
		<div v-if="isVisible" class="camera-reset-button-overlay">
			<AppIconButton :type="IconTypes.CENTER" @click="handleClick" />
		</div>
	</Transition>
</template>

<script setup lang="ts">
import AppIconButton from "@/components/AppIconButton.vue";
import useEmitter, { EmitterEvents } from "@/hooks/useEmitter";
import { IconTypes } from "@/types/ui";

import { onMounted, onUnmounted, ref } from "vue";

const emitter = useEmitter();
const isVisible = ref<boolean>(false);

const handleClick = (): void => {
	isVisible.value = false;

	// Emit the go to capital event
	emitter.emit(EmitterEvents.PhaserGoToCapital);
};

const showButton = (): void => {
	isVisible.value = true;
};

const hideButton = (): void => {
	isVisible.value = false;
};

onMounted((): void => {
	emitter.on(EmitterEvents.PhaserShowCameraResetButton, showButton);
	emitter.on(EmitterEvents.PhaserHideCameraResetButton, hideButton);
});

onUnmounted((): void => {
	emitter.off(EmitterEvents.PhaserShowCameraResetButton, showButton);
	emitter.off(EmitterEvents.PhaserHideCameraResetButton, hideButton);
});
</script>

<style lang="scss" scoped>
.camera-reset-button-overlay {
	position: relative;
	left: 0;
	z-index: 0;
	margin: 0.25rem 0;
}

.fade-enter-active,
.fade-leave-active {
	transition: all 0.3s ease;
}

.fade-enter-from {
	transform: translateX(-50%) scale(0.8);
	opacity: 0;
}

.fade-leave-to {
	transform: translateX(-50%) scale(0.8);
	opacity: 0;
}
</style>
